module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic_1.f83638f5.ttf";